import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AbstractHttpService } from '../../services/http/http-service.abstract';
import { ApiFragment } from '../entities/api-fragment.entity';
import { Metadata } from '../entities/metadata.entity';

enum VersionId {
    draft = 'draft',
    head = 'head',
    latest = 'latest'
}

@Injectable()
export class VersioningService {
    private readonly ENDPOINT: string = 'versionings';
    constructor(private httpService: AbstractHttpService) {}

    getRecordVersion(versioningId: string, versionId: string | VersionId): Observable<ApiFragment> {
        const endpoint = `${this.ENDPOINT}/${versioningId}/versions/${versionId}`;

        return this.httpService.get<Metadata>(endpoint).pipe(map(metadata => new ApiFragment(metadata)));
    }
}
